import dedent from "dedent";
import { sprinkles } from "./sprinkles.css.mjs";
import { base, element } from "../reset/reset.css.mjs";
const atoms = ({ reset, ...rest }) => {
  if (!reset) {
    return sprinkles(rest);
  }
  if (process.env.NODE_ENV !== "production") {
    if (rest.outline && rest.outline === "none") {
      console.warn(
        dedent`
          \`outline='none'\` is deprecated and will be removed in a future release.

          Braid manages the focus outlines of interactive elements as part of its
          scoped CSS reset.

          For a custom focus outlines on non-interactive elements, consider
          \`outline='focus'\` or \`outlineStyle\` for more complex scenarios.

          See documentation:
          1. https://seek-oss.github.io/braid-design-system/components/Box#focus-outlines
          2. https://seek-oss.github.io/braid-design-system/css/outlineStyle
        `
      );
    }
    if (rest.boxShadow && rest.boxShadow === "outlineFocus") {
      console.warn(
        dedent`
          \`outline='none'\` is deprecated and will be removed in a future release.

          Braid no longer uses the \`box-shadow\` for focus outlines.
          Instead, consider \`outline='focus'\` or the \`outlineStyle\` css utility.

          See documentation:
          1. https://seek-oss.github.io/braid-design-system/components/Box#focus-outlines
          2. https://seek-oss.github.io/braid-design-system/css/outlineStyle
        `
      );
    }
  }
  const elementReset = element[reset];
  const sprinklesClasses = sprinkles(rest);
  return `${base}${elementReset ? ` ${elementReset}` : ""}${sprinklesClasses ? ` ${sprinklesClasses}` : ""}`;
};
export {
  atoms
};
